import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';

import { SearchResultsListViewModel } from './SearchResultsList.types';
import SearchPreviewCard from '@/components/SearchPreviewCard/SearchPreviewCard.vue';
import LinkItem from '@/common/interfaces/LinkItem';

const SearchResultsListProps = Vue.extend({
  props: getComponentProps<SearchResultsListViewModel>({
    Title: 'Default List title',
    //IsNarrow: false,
    Items: ['Demo 1', 'Demo 2', 'Demo 3'],
  }),
});

@Component({
  components: {
    SearchPreviewCard,
  },
})
export default class SearchResultsList extends SearchResultsListProps {
  @Prop() readonly SearchCta: LinkItem;
  handleClick(data) {
    this.$emit('selected', data);
  }
}
